export default {
  black: '#000',
  danger: '#c53030',
  dark: '#444',
  darkGrey: '#999',
  grey: '#ddd',
  info: '#4d85ee',
  lightGrey: '#eee',
  primary: '#ee4d64',
  secondary: '#312e38',
  success: '#31DB7D',
  white: '#fff',
  brand: '#ff9000',
  // form variables
  inputBg: '#232129',
  inputBd: '#232129',
  inputTxt: '#f4ede8',
  inputPh: '#666360',
  btnBg: '#ff9000',
  btnTxt: '#312e38',
  lnkAux: '#f4ede8',
  lnkTxt: '#ff9000',
  // tooltip
  ttTxt: '#312e38',
  // toast
  toBg: '#ebf8ff',
  toTxt: '#3172b7',
  toSuccessBg: '#e6fffa',
  toSuccessTxt: '#2e656a',
  toErrorBg: '#fddede',
  toErrorTxt: '#c53030',
  // header
  headerBg: '#28262E',
  headerBtn: '#999591',
  headerTxt: '#999591',
  // dashboard
  dashTitleh1: '#F4EDE8',
  dashTitleh2: '#999591',
  dashBgNext: '#3E3B47',
  dashTxtClock1: '#999591',
  dashTxtClock2: '#F4EDE8',
  dashLine: '#3E3B47',
  // calendar
  calendarBgDefault: '#3E3B47',
  calendarTxtDefault: '#F4EDE8',
  calendarTxtToday: '#232129',
};
